
import wsp from '../../../assets/images/wsp.png'
import wsdnr from '../../../assets/images/wsdnr.png'
import fandw from '../../../assets/images/fandw.png'
import './Footer.css';
export const Footer = ()=>{
    return(
        <>
            <footer className="text-light">
                {/* Logos Section */}
                <div className="logoFooter d-flex justify-content-center align-items-center py-4 mb-4">
                    <a href="http://parks.state.wa.us/">
                        <img src={wsp} alt="Washington State Parks" className="img-fluid"/>
                    </a>
                    <a href="http://www.dnr.wa.gov/">
                        <img src={wsdnr} alt="Washington State Department of Natural Resources" className="img-fluid"/>
                    </a>
                    <a href="http://wdfw.wa.gov/">
                        <img src={fandw} alt="Washington Dept. of Fish and Wildlife" className="img-fluid"/>
                    </a>
                </div>
                {/* Footer Links & Info */}
                <div className="textFooter d-flex justify-content-between align-items-center">
                    {/* Links Section */}
                    <div className="textFooter-links py-4">
                        <a href="http://discoverpass.wa.gov/faq.aspx" target="_blank">FAQs</a>
                        <a href="http://discoverpass.wa.gov/Accessibility" target="_blank">Accessibility</a>
                        <a href="http://discoverpass.wa.gov/site/copyright" target="_blank">Copyright</a>
                        <a href="https://discoverpass.wa.gov/124/Privacy-Policy" target="_blank">Privacy Policy</a>
                    </div>
                    {/* Contact Info */}
                    <div className="textFooter-info py-4 text-end">
                        <div className="textFooter-info-head">Questions about your order?</div>
                        <p>
                            Call: 844-271-7041<br/>
                            <a href="mailto:discoverpass@dcgone.com">discoverpass@dcgone.com</a><br/>
                            Monday to Friday 8:00 AM to 4:30 PM PT<br/>
                            Saturday and Sunday: Closed
                        </p>
                    </div>
                </div>
            </footer>
        </>
    )
}